"use client"

import dynamic from "next/dynamic"
import { DeferredHydration } from "@/components/client/DeferredHydration"

const SiteFooterClient = dynamic(
  () => import("@/components/client/SiteFooter/SiteFooterClient"),
  { ssr: false },
)

export default function DeferredSiteFooter(props: { data: any }) {
  return (
    <DeferredHydration minHeight="320px">
      <SiteFooterClient {...props} />
    </DeferredHydration>
  )
}
